export default {
    list: "email/list",
    add: 'email/add',

    customersToNotify: 'email/customersToNotify',

    //TODO: Server side code
    linkToReport: 'email/linkToReport',
    unlinkFromReport: 'email/unlinkFromReport',
    setAllForReport: 'email/setAllForReport',

    //Compose Section
    preview: 'email/preview',
    send: 'email/send',

    //Template CRUD
    addTemplate: 'email/addTemplate',
    listTemplates: 'email/listTemplates',
    deleteTemplate: 'email/deleteTemplate',
    editTemplate: 'email/editTemplate'
}
